import {inject, Injectable} from "@angular/core";
import {FxApiService} from "../../generated-sources/api/fx";

@Injectable({
    providedIn: "root"
})
export class FxService {
    private readonly fxApiService = inject(FxApiService);

    constructor( ) {
    }

    getCurrencies() {
        return this.fxApiService.getCurrencies();
    }

    getLatestExchangeRates(from: string, to: string, amount: number) {
        if (!!from && !!to && !!amount) {
            return this.fxApiService.getLatestExchangeRates(from, to, amount);
        } else if (!!from && !to) {
            return this.fxApiService.getLatestExchangeRates(from, undefined, amount);
        } else {
            return this.fxApiService.getLatestExchangeRates();
        }
    }

    getHistoricalExchangeRates(date: string, from: string, to: string) {
        return this.fxApiService.getHistoricalExchangeRates(date, from, to);
    }
}
